import { FC } from 'react';
import { useSnapshot } from 'valtio';
import CollapsiblePanel from '../../elements/CollapsiblePanel/CollapsiblePanel';
import Summary from '../../elements/Summary/Summary';
import { Box } from '@mui/material';
import FiltersHeader from '../../elements/FilterBox/FiltersHeader';
import { splitLongNames } from 'string-utils';
import SbomStore from '../stores/sbom-store';
import SbomFiltersStore from '../stores/sbom-filters-store';
import { toggleFiltersPanel } from '../stores/sbom-store-actions';
import { clearFilters } from '../stores/sbom-filters-store-actions';
import SbomSidebar from '../components/SbomSidebar';
import config from '../config/sbom-config.json';

const SbomSidebarContainer: FC<React.PropsWithChildren<unknown>> = () => {
  const { total, filtersOpen, loading } = useSnapshot(SbomStore);
  const {
    loadingFilters,
    filterBy,
    librariesFiltersType,
    librariesFiltersTypeSearch,
    numberOfFilters,
    totalFilters,
    searchValues,
  } = useSnapshot(SbomFiltersStore);

  return (
    <CollapsiblePanel
      collapsedSize={config.sidebar.collapsedSize}
      in={filtersOpen}
      togglePanel={toggleFiltersPanel}>
      <SbomSidebar
        disabled={loading.isPending() || loadingFilters.isPending()}
        filterList={filterBy}
        librariesFiltersTypeSearch={librariesFiltersTypeSearch}
        librariesFiltersType={librariesFiltersType}
        totalLibraries={total}
        loadingFilters={loadingFilters}
        searchValues={searchValues}>
        <Summary
          headerText='SBOM'
          total={total}
          count={totalFilters}
          onCollapse={toggleFiltersPanel}
        />
        <Box py={1}>
          <FiltersHeader
            numberOfFilters={numberOfFilters}
            filterIssuesBy={filterBy}
            onResetFilters={clearFilters}
            splitFilterTypeName={splitLongNames}
          />
        </Box>
      </SbomSidebar>
    </CollapsiblePanel>
  );
};

export default SbomSidebarContainer;
